import { sheetsBaseUrl, l10nBaseUrl } from '@rb/shared/master-data/cdn-config';

function origin(): string {
  const v = import.meta.env.VITE_R2_PUBLIC_BASE as string | undefined;
  if (!v) {
    throw new Error('VITE_R2_PUBLIC_BASE is not set (origin URL required)');
  }
  return v;
}

/** R2 public CDN origin (예: https://sheets.ragnarokbreaker.fun). 업로드 키를 공개 URL 로 조립할 때 사용. */
export function getCdnOrigin(): string {
  return origin();
}

/** 어드민 UI 번역 채널 슬러그 (root .env 의 VITE_SHEET_ENV 기준, 기본 dev). */
export function getSheetEnv(): string {
  return (import.meta.env.VITE_SHEET_ENV as string | undefined) || 'dev';
}

export function getSheetsBase(): string {
  return sheetsBaseUrl(origin());
}

export function getL10nBase(sheetEnv: string): string {
  return l10nBaseUrl(origin(), sheetEnv);
}
